import { render, staticRenderFns } from "./CRFinanicalInsights.vue?vue&type=template&id=b4a0d922"
import script from "./CRFinanicalInsights.vue?vue&type=script&lang=js"
export * from "./CRFinanicalInsights.vue?vue&type=script&lang=js"
import style0 from "./CRFinanicalInsights.vue?vue&type=style&index=0&id=b4a0d922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports